const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const DIACRITICS_RE = /[̀-ͯ]/g;

export function slugify(text) {
  return (text || '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(DIACRITICS_RE, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Builds an SEO-friendly book detail path, e.g. /book/the-great-gatsby-<id>.
// The id always stays at the end so extractBookId() can recover it.
export function bookPath(book) {
  const slug = slugify(book.title);
  return slug ? `/book/${slug}-${book.id}` : `/book/${book.id}`;
}

// Recovers the raw book id from a `/book/:bookId` route param, whether it's
// a slugged path segment or (for old bookmarks/links) a bare id.
export function extractBookId(param) {
  const match = UUID_RE.exec(param || '');
  return match ? match[0] : param;
}
